import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFlagD = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_2056_28813)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z",
			fill: "#8033CC"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M4.90163 3.82296H8.05842C8.61056 3.82296 9.11469 3.91098 9.5708 4.08702C10.0269 4.26307 10.415 4.52713 10.7351 4.87922C11.0552 5.22331 11.3032 5.65942 11.4793 6.18755C11.6553 6.70768 11.7433 7.31583 11.7433 8.012C11.7433 8.70818 11.6553 9.32033 11.4793 9.84846C11.3032 10.3686 11.0552 10.8047 10.7351 11.1568C10.415 11.5009 10.0269 11.7609 9.5708 11.937C9.11469 12.113 8.61056 12.2011 8.05842 12.2011H4.90163V3.82296ZM8.05842 10.5806C8.60256 10.5806 9.03066 10.4286 9.34274 10.1245C9.65482 9.82046 9.81086 9.33233 9.81086 8.66017V7.36384C9.81086 6.69167 9.65482 6.20355 9.34274 5.89948C9.03066 5.5954 8.60256 5.44336 8.05842 5.44336H6.72609V10.5806H8.05842Z",
			fill: "white"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_2056_28813",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgFlagD;
